import { shallowEqual, useSelector } from "react-redux";

export function getVendorUser({ state }) {
  return state?.auth?.vendor?.user;
}

export function getCurrentUsers({ store }) {
  const state = store.getState();

  return {
    vendor: {
      user: getVendorUser({ state }),
      signInPath: "/provider/auth",
    },
  };
}

export default function useVendorUser() {
  return useSelector((state) => getVendorUser({ state }), shallowEqual);
}
